import React from "react";
import Stack from "@mui/material/Stack";
import ModalPanel from "./ModalPanel";
import RequestButton from "../buttons/RequestButton";
import { MainTitle, MainText } from "../../data/style/Style";

export const ConfirmActionModal = ({
  active,
  setActive,
  text,
  action,
  func,
}) => {
  return (
    <ModalPanel active={active} setActive={setActive}>
      <Stack gap={1}>
        <MainTitle>Confirm Action</MainTitle>
        <MainText>{text}</MainText>
        <Stack direction={"row"} gap={2} width={"40%"} alignSelf={"end"}>
          <RequestButton
            text={"Abort"}
            small={true}
            alt={true}
            onClick={() => setActive(false)}
          />
          <RequestButton text={action} small={true} onClick={func} />
        </Stack>
      </Stack>
    </ModalPanel>
  );
};
